module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgB5ZUBCoAgDEVneBCP1lG6SR3Nm1iGRdQ2v5YQ9SD6MP6W30FEvyKE0MeHWpCab/SoryMcJ+j6AblIkMisZl5eY9LZujFm4vpoJ3CCRuvXAXe3hPPbY5GUSJDmxER2PIETNIrjdMmaVvGtAV7QKJ7T+xbFW9+2J+mBCjj7LwPOhRo4v3YHXtBofcVqX6NFJkUCD8gZkXqkZE29oJ+j6S/ztcxau3j5qCrMmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Images/audiowhticn.png
// module id = 1175
// module chunks = 0